import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { useEventCalendarList } from "../store";
import { cls_table_body, cls_table_caption_row, cls_table_cell, cls_table_row } from "style/table.css";
import { cls_gap_form, cls_gap_rem, cls_p5b, cls_p5r } from "style/index.css";
import { CompetitionType, OfficialRole } from "../../entity";
import { getOfficialRoleName } from "../../../officials/entity";
import { cls_propositions_text } from "../propositions/view.css";
import { cls_align_items_center, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { getDateAndTimeText_DayMonthHourMinute } from "framework/helpers";
import { useEventCalendarCompetitions } from "../competitions/store";
import { useEventCalendarOfficials } from "./store";
import { LoadingError, LoadingSpinner } from "framework/controls/loading";
var View = function () {
    var state = useEventCalendarList()[0];
    var _a = useEventCalendarCompetitions(), state_competitions = _a[0], actions_competitions = _a[1];
    var p = state.selectedEventItem;
    var _b = useEventCalendarOfficials(), state_officials = _b[0], actions_officials = _b[1];
    React.useEffect(function () {
        actions_officials.loadOfficials(p.eventId);
        actions_competitions.invalidate();
        actions_competitions.loadCompetitions(p.eventId, p.eventId, "type");
    }, [p.eventId]);
    var numberOfAdjudicators = state_officials.collection.filter(function (o) { return o.role == OfficialRole.Adjudicator; }).length;
    var containsChampionship = state_competitions.collection.filter(function (c) { return c.typeId === CompetitionType.Championship; }).length > 0;
    var showInfoAboutAdjudicatorsFutureAddition = containsChampionship && numberOfAdjudicators < 9;
    var loading = state_officials.loading;
    var loadingTooLong = state_officials.loadingTooLong;
    var loadFailure = state_officials.loadFailure;
    var showContent = !loading && !loadFailure;
    return React.createElement(React.Fragment, null,
        showContent && React.createElement(VBox, { className: [cls_gap_form, cls_align_items_stretch] },
            React.createElement(VBox, { className: cls_align_items_flex_start },
                React.createElement(HBox, { className: cls_gap_rem },
                    React.createElement(VBox, { className: cls_p5b }, "Porada poroty:"),
                    React.createElement(VBox, { className: cls_p5r }, getDateAndTimeText_DayMonthHourMinute(p.juryMeeting)))),
            showInfoAboutAdjudicatorsFutureAddition && React.createElement(HBox, { className: cls_p5r }, "Seznam porotc\u016F nen\u00ED kompletn\u00ED. Podle SC01 \u00A71/2 budou porotci dopln\u011Bni t\u0159i dny p\u0159ed kon\u00E1n\u00EDm akce."),
            React.createElement(VBox, { className: [cls_gap_form, cls_align_items_stretch] },
                React.createElement(VBox, null,
                    React.createElement(HBox, { className: [cls_table_caption_row] },
                        React.createElement(VBox, { className: [cls_table_cell, cls_justify_content_center, cls_p5b] }, "Porota")),
                    React.createElement(VBox, { className: [cls_table_body] }, state_officials.collection.filter(function (o) { return o.role == OfficialRole.Adjudicator; }).sort(function (a, b) {
                        var result;
                        result = a.surname.localeCompare(b.surname, 'cs');
                        if (result > 0) {
                            return 1;
                        }
                        if (result < 0) {
                            return -1;
                        }
                        result = a.name.localeCompare(b.name, 'cs');
                        if (result > 0) {
                            return 1;
                        }
                        if (result < 0) {
                            return -1;
                        }
                        return 0;
                    }).map(function (official) { return React.createElement(HBox, { key: official.id, className: cls_table_row },
                        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_p5r] },
                            official.surname,
                            " ",
                            official.name,
                            " (",
                            official.countryCode,
                            ")")); }))),
                React.createElement(VBox, null,
                    React.createElement(HBox, { className: [cls_table_caption_row] },
                        React.createElement(VBox, { className: [cls_table_cell, cls_justify_content_center, cls_p5b] }, "Funkcionáři")),
                    React.createElement(VBox, { className: [cls_table_body] }, state_officials.collection.filter(function (o) { return o.role != OfficialRole.Adjudicator; }).sort(function (a, b) {
                        var result;
                        if (a.role > b.role) {
                            return 1;
                        }
                        if (a.role < b.role) {
                            return -1;
                        }
                        result = a.surname.localeCompare(b.surname, 'cs');
                        if (result > 0) {
                            return 1;
                        }
                        if (result < 0) {
                            return -1;
                        }
                        result = a.name.localeCompare(b.name, 'cs');
                        if (result > 0) {
                            return 1;
                        }
                        if (result < 0) {
                            return -1;
                        }
                        return 0;
                    }).map(function (official) { return React.createElement(HBox, { key: official.id, className: cls_table_row },
                        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_p5r] },
                            official.surname,
                            " ",
                            official.name,
                            " - ",
                            getOfficialRoleName(official.role))); })))),
            p.costs ? React.createElement(VBox, { className: cls_align_items_flex_start },
                React.createElement(HBox, { className: cls_p5b }, "Odměny odborným pracovníkům"),
                React.createElement(HBox, { className: [cls_p5r, cls_propositions_text] }, p.costs)) : React.createElement(React.Fragment, null)),
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null));
};
export { View as Officials, };
